var _path, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSl10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 16,
    viewBox: "0 0 80 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "#4E79A7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 16,
    height: 16,
    fill: "#F28E2C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    width: 16,
    height: 16,
    fill: "#E15759"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    width: 16,
    height: 16,
    fill: "#76B7B2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    width: 16,
    height: 16,
    fill: "#59A14F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSl10);
export default __webpack_public_path__ + "static/media/sl_10.af9b118903992aeef5051af49ec499ac.svg";
export { ForwardRef as ReactComponent };